import type { Translations } from '../../types'

const productTypeStudioMessages: Translations = {
  'productTypeStudio.common.loading': 'Caricamento...',
  'productTypeStudio.common.loadingMore': 'Caricamento altri risultati...',
  'productTypeStudio.common.loadMoreResults': 'Carica altri risultati',
  'productTypeStudio.common.edit': 'Modifica',
  'productTypeStudio.common.delete': 'Elimina',
  'productTypeStudio.common.cancel': 'Annulla',
  'productTypeStudio.common.close': 'Chiudi',
  'productTypeStudio.common.save': 'Salva',
  'productTypeStudio.common.create': 'Crea',
  'productTypeStudio.common.remove': 'Rimuovi',
  'productTypeStudio.common.duplicate': 'Duplica',
  'productTypeStudio.common.nA': 'n/d',
  'productTypeStudio.common.unavailable': 'non disponibile',
  'productTypeStudio.common.draft': 'Bozza',
  'productTypeStudio.common.saved': 'Salvato',
  'productTypeStudio.common.active': 'Attivo',
  'productTypeStudio.common.deprecated': 'Deprecato',
  'productTypeStudio.common.hidden': 'Nascosto',
  'productTypeStudio.common.default': 'Predefinito',
  'productTypeStudio.common.yes': 'Sì',
  'productTypeStudio.common.no': 'No',
  'productTypeStudio.common.required': 'Obbligatorio',
  'productTypeStudio.common.optional': 'Opzionale',
  'productTypeStudio.common.attributes': 'attributi',
  'productTypeStudio.common.attribute': 'attributo',
  'productTypeStudio.common.displayComponent': 'Componente di visualizzazione',
  'productTypeStudio.common.displayComponents': 'Componenti di visualizzazione',
  'productTypeStudio.common.variantOption': 'Opzione variante',
  'productTypeStudio.common.variantSpecificValue': 'Valore specifico variante',
  'productTypeStudio.common.sharedValue': 'Valore condiviso',
  'productTypeStudio.common.advanced': 'Avanzate',
  'productTypeStudio.common.developer': 'Sviluppatore',
  'productTypeStudio.brand': 'Studio modelli prodotto',
  'productTypeStudio.navigation.studio': 'Studio',
  'productTypeStudio.preview.storefront': 'Anteprima vetrina',
  'productTypeStudio.preview.whatShoppersSee': 'Questo è ciò che vedono i clienti',
  'productTypeStudio.preview.view': 'Visualizza',
  'productTypeStudio.preview.edit': 'Modifica',
  'productTypeStudio.preview.desktop': 'Desktop',
  'productTypeStudio.preview.mobile': 'Mobile',
  'productTypeStudio.preview.defaultSubtitle': 'Prodotto professionale con configurazione flessibile per team tecnici e creativi.',
  'productTypeStudio.fieldTypes.text': 'Testo',
  'productTypeStudio.fieldTypes.textarea': 'Testo lungo',
  'productTypeStudio.fieldTypes.number': 'Numero',
  'productTypeStudio.fieldTypes.boolean': 'Sì / No',
  'productTypeStudio.fieldTypes.select': 'Selezione',
  'productTypeStudio.fieldTypes.richtext': 'Testo formattato',
  'productTypeStudio.fieldTypes.media': 'Media',
  'productTypeStudio.fieldTypes.date': 'Data',
  'productTypeStudio.fieldZones.summary': 'Riepilogo',
  'productTypeStudio.fieldZones.highlights': 'In evidenza',
  'productTypeStudio.fieldZones.specs': 'Specifiche',
  'productTypeStudio.fieldZones.details': 'Dettagli',
  'productTypeStudio.fieldZones.documents': 'Documenti',
  'productTypeStudio.fieldZones.sidebar': 'Barra laterale acquisto',
  'productTypeStudio.fieldStatuses.active': 'Attivo',
  'productTypeStudio.fieldStatuses.deprecated': 'Deprecato',
  'productTypeStudio.fieldStatuses.hidden': 'Nascosto',
  'productTypeStudio.variantStates.choice': 'Opzione variante',
  'productTypeStudio.variantStates.choiceDescription': 'Crea scelte selezionabili dal cliente',
  'productTypeStudio.variantStates.specific': 'Valore specifico variante',
  'productTypeStudio.variantStates.specificDescription': 'Può differire per variante',
  'productTypeStudio.variantStates.shared': 'Valore condiviso',
  'productTypeStudio.variantStates.sharedDescription': 'Condiviso tra tutte le varianti',
  'productTypeStudio.renderer.scopeCore': 'Componente di visualizzazione integrato',
  'productTypeStudio.renderer.scopeCustom': 'Componente di visualizzazione personalizzato',
  'productTypeStudio.renderer.status.draft': 'Bozza',
  'productTypeStudio.renderer.status.valid': 'Verificato',
  'productTypeStudio.renderer.status.invalid': 'Non valido',
  'productTypeStudio.renderer.status.unavailable': 'Non disponibile',
  'productTypeStudio.renderer.type.default': 'Template base (senza codice)',
  'productTypeStudio.renderer.type.customJs': 'JavaScript personalizzato',
  'productTypeStudio.renderer.defaultLabel': 'Componente di visualizzazione predefinito',
  'productTypeStudio.renderer.customDraftLabel': 'Componente di visualizzazione personalizzato (bozza)',
  'productTypeStudio.renderer.customLabelPrefix': 'Componente di visualizzazione personalizzato',
  'productTypeStudio.sectionHeaders.eyebrow': 'Modelli prodotto',
  'productTypeStudio.sectionHeaders.title': 'Modelli prodotto',
  'productTypeStudio.sectionHeaders.subtitle': 'Definisci e gestisci i modelli prodotto e i loro attributi.',
  'productTypeStudio.sectionHeaders.definedModels': 'Modelli definiti',
  'productTypeStudio.sectionHeaders.refresh': 'Aggiorna',
  'productTypeStudio.sectionHeaders.new': 'Nuovo modello prodotto',
  'productTypeStudio.accessDenied': 'I modelli prodotto richiedono la capability manage_product_type_studio.',
  'productTypeStudio.accessDeniedTitle': 'Accesso non consentito',
  'productTypeStudio.editor.newModel': 'Nuovo modello prodotto',
  'productTypeStudio.editor.idUnavailable': 'ID non disponibile',
  'productTypeStudio.editor.tab.overview': 'Panoramica',
  'productTypeStudio.editor.tab.attributes': 'Attributi',
  'productTypeStudio.editor.tab.variants': 'Varianti',
  'productTypeStudio.editor.tab.productEditorPreview': 'Anteprima editor prodotto',
  'productTypeStudio.editor.tab.productPage': 'Pagina prodotto',
  'productTypeStudio.editor.tab.publish': 'Pubblica',
  'productTypeStudio.editor.tab.advanced': 'Avanzate',
  'productTypeStudio.editor.save': 'Salva modello prodotto',
  'productTypeStudio.editor.close': 'Chiudi editor',
  'productTypeStudio.editor.routeMissing': 'Modello prodotto non trovato',
  'productTypeStudio.editor.headerAttributes': 'attributi',
  'productTypeStudio.editor.headerDraft': 'Bozza',
  'productTypeStudio.editor.headerSaved': 'Salvato',
  'productTypeStudio.editorHeader.mode': 'Modalità componente di visualizzazione',
  'productTypeStudio.editorHeader.standard': 'Standard',
  'productTypeStudio.editorHeader.displayComponent': 'Componente di visualizzazione',
  'productTypeStudio.editorMetadata.id': 'ID modello prodotto',
  'productTypeStudio.editorMetadata.name': 'Nome modello',
  'productTypeStudio.editorMetadata.version': 'Versione modello',
  'productTypeStudio.editorMetadata.description': 'Descrizione',
  'productTypeStudio.editorMetadata.idPlaceholder': 'sportswear',
  'productTypeStudio.editorMetadata.namePlaceholder': 'Sportswear',
  'productTypeStudio.editorMetadata.versionPlaceholder': '1.0.0',
  'productTypeStudio.fieldEditor.header.create': 'Nuovo attributo',
  'productTypeStudio.fieldEditor.header.edit': 'Modifica attributo',
  'productTypeStudio.fieldEditor.header.placement': 'Posizionamento: {{label}}',
  'productTypeStudio.fieldEditor.header.mode': 'Modalità componente di visualizzazione',
  'productTypeStudio.fieldEditor.header.standard': 'Standard',
  'productTypeStudio.fieldEditor.section.main.title': 'Configurazione principale',
  'productTypeStudio.fieldEditor.section.main.description': 'Imposta nome, tipo e struttura di base dell’attributo.',
  'productTypeStudio.fieldEditor.section.presentation.title': 'Componente di visualizzazione / Presentazione',
  'productTypeStudio.fieldEditor.section.presentation.rendererDescription': 'Configura il componente di visualizzazione che guida la presentazione dell’attributo.',
  'productTypeStudio.fieldEditor.section.presentation.standardDescription': 'In modalità Standard viene usato il componente di visualizzazione predefinito.',
  'productTypeStudio.fieldEditor.section.data.title': 'Opzioni attributo',
  'productTypeStudio.fieldEditor.section.data.description': 'Regole, default e opzioni in base al tipo.',
  'productTypeStudio.fieldEditor.section.advanced.title': 'Impostazioni avanzate',
  'productTypeStudio.fieldEditor.section.advanced.description': 'Contesto slot e metadati non primari.',
  'productTypeStudio.fieldEditor.validation.title': 'Validazione',
  'productTypeStudio.fieldEditor.advanced.placement': 'Posizionamento',
  'productTypeStudio.fieldEditor.advanced.placementHint': 'Derivato automaticamente dallo slot selezionato.',
  'productTypeStudio.fieldEditor.advanced.attributeKey': 'Chiave attributo',
  'productTypeStudio.fieldEditor.advanced.notSet': 'Non impostata',
  'productTypeStudio.fieldEditor.advanced.ownership': 'Proprietà',
  'productTypeStudio.fieldEditor.advanced.ownership.parent': 'Padre',
  'productTypeStudio.fieldEditor.advanced.ownership.variant': 'Variante',
  'productTypeStudio.fieldEditor.advanced.ownership.both': 'Entrambi',
  'productTypeStudio.fieldEditor.advanced.variants': 'Varianti',
  'productTypeStudio.fieldEditor.advanced.overrideable': 'Override consentito',
  'productTypeStudio.fieldEditor.advanced.variantAttribute': 'Attributo variante',
  'productTypeStudio.fieldEditor.advanced.display': 'Visualizzazione',
  'productTypeStudio.fieldEditor.advanced.visibleSummary': 'Visibile nel riepilogo della vetrina',
  'productTypeStudio.fieldEditor.advanced.visibleSpecs': 'Visibile nelle specifiche',
  'productTypeStudio.fieldEditor.advanced.displayOrder': 'Ordine di visualizzazione',
  'productTypeStudio.fieldEditor.advanced.metadata': 'Metadata avanzata',
  'productTypeStudio.fieldEditor.advanced.searchable': 'Ricercabile',
  'productTypeStudio.fieldEditor.advanced.filterable': 'Filtrabile',
  'productTypeStudio.fieldEditor.advanced.sortable': 'Ordinabile',
  'productTypeStudio.fieldEditor.advanced.aiHints': 'Suggerimenti AI',
  'productTypeStudio.fieldEditor.advanced.aiExamples': 'Esempi AI',
  'productTypeStudio.fieldEditor.advanced.aiExamplesPlaceholder': 'Una riga per esempio',
  'productTypeStudio.fieldEditor.advanced.importAliases': 'Alias di importazione',
  'productTypeStudio.fieldEditor.advanced.importAliasesPlaceholder': 'Una riga per alias',
  'productTypeStudio.fieldEditor.advanced.status': 'Stato attributo',
  'productTypeStudio.fieldEditor.advanced.status.active': 'Attivo',
  'productTypeStudio.fieldEditor.advanced.status.deprecated': 'Deprecato',
  'productTypeStudio.fieldEditor.advanced.status.hidden': 'Nascosto',
  'productTypeStudio.fieldEditor.presentation.standardHint': 'Componente di visualizzazione attivo: Predefinito. Passa alla modalità componente di visualizzazione per usare un componente personalizzato.',
  'productTypeStudio.fieldEditor.presentation.renderer': 'Componente di visualizzazione',
  'productTypeStudio.fieldEditor.presentation.newDisplayComponent': '+ Nuovo componente di visualizzazione',
  'productTypeStudio.fieldEditor.presentation.dataType': 'Tipo dato',
  'productTypeStudio.fieldEditor.presentation.rendererDerived': 'derivato dal componente di visualizzazione',
  'productTypeStudio.fieldEditor.presentation.rendererControlsType': 'Questo componente di visualizzazione controlla automaticamente il tipo attributo.',
  'productTypeStudio.fieldEditor.presentation.compatibleType': 'Tipo dato compatibile',
  'productTypeStudio.fieldEditor.presentation.compatibleTypeLimited': 'Il componente di visualizzazione selezionato limita i tipi disponibili.',
  'productTypeStudio.fieldEditor.main.attributeKey': 'Chiave attributo',
  'productTypeStudio.fieldEditor.main.attributeKeyPlaceholder': 'es. energy_class',
  'productTypeStudio.fieldEditor.main.attributeName': 'Nome attributo',
  'productTypeStudio.fieldEditor.main.attributeNamePlaceholder': 'es. Classe energetica',
  'productTypeStudio.fieldEditor.main.dataType': 'Tipo dato',
  'productTypeStudio.fieldEditor.main.productPageSection': 'Sezione pagina prodotto',
  'productTypeStudio.fieldEditor.data.technicalUnit': 'Unità tecnica',
  'productTypeStudio.fieldEditor.data.technicalUnitPlaceholder': 'es. BTU, kW, mm, kg',
  'productTypeStudio.fieldEditor.data.min': 'Min',
  'productTypeStudio.fieldEditor.data.max': 'Max',
  'productTypeStudio.fieldEditor.data.pattern': 'Pattern',
  'productTypeStudio.fieldEditor.data.patternPlaceholder': 'Espressione regolare opzionale',
  'productTypeStudio.fieldEditor.data.defaultValue': 'Valore predefinito',
  'productTypeStudio.fieldEditor.data.defaultValueOptional': 'Valore predefinito (opzionale)',
  'productTypeStudio.fieldEditor.data.defaultValuePlaceholder': 'Valore iniziale',
  'productTypeStudio.fieldEditor.data.selectValuePlaceholder': 'value opzione (es. eco)',
  'productTypeStudio.fieldEditor.data.none': 'Nessuno',
  'productTypeStudio.fieldEditor.data.options': 'Opzioni',
  'productTypeStudio.fieldEditor.data.optionsPlaceholder': 'eco|Eco\npremium|Premium',
  'productTypeStudio.fieldEditor.data.optionsHelp': 'Una riga per opzione, formato',
  'productTypeStudio.rendererCreate.closeAria': 'Chiudi creazione componente di visualizzazione',
  'productTypeStudio.rendererCreate.eyebrow': 'Nuovo componente di visualizzazione',
  'productTypeStudio.rendererCreate.title': 'Aggiungi un componente di visualizzazione a questo attributo',
  'productTypeStudio.rendererCreate.description': 'Puoi caricare un pacchetto ZIP oppure partire da una bozza inline.',
  'productTypeStudio.rendererCreate.displayName': 'Nome visualizzato',
  'productTypeStudio.rendererCreate.displayNamePlaceholder': 'Badge energetico',
  'productTypeStudio.rendererCreate.creationMode': 'Modalità creazione',
  'productTypeStudio.rendererCreate.inlineDraft': 'Bozza inline',
  'productTypeStudio.rendererCreate.uploadZip': 'Carica pacchetto ZIP',
  'productTypeStudio.rendererCreate.draftType': 'Tipo bozza',
  'productTypeStudio.rendererCreate.defaultTemplate': 'Template base (senza codice)',
  'productTypeStudio.rendererCreate.customJs': 'JS personalizzato',
  'productTypeStudio.rendererCreate.version': 'Versione (opzionale)',
  'productTypeStudio.rendererCreate.descriptionLabel': 'Descrizione (opzionale)',
  'productTypeStudio.rendererCreate.descriptionPlaceholder': 'Componente di visualizzazione personalizzato per badge energetico',
  'productTypeStudio.rendererCreate.zipPackage': 'Pacchetto componente di visualizzazione (.zip)',
  'productTypeStudio.rendererCreate.selectedFile': 'File selezionato',
  'productTypeStudio.rendererCreate.zipHelp': 'Carica il pacchetto del componente di visualizzazione esportato in formato ZIP.',
  'productTypeStudio.rendererCreate.draftCode': 'Codice JS (bozza)',
  'productTypeStudio.rendererCreate.draftCodePlaceholder': 'export default function render(value) {\n  return String(value)\n}',
  'productTypeStudio.rendererCreate.draftCodeHelp': 'Usa una bozza semplice. Potrai rifinire il componente di visualizzazione anche dal registro.',
  'productTypeStudio.rendererCreate.creating': 'Creazione...',
  'productTypeStudio.rendererCreate.create': 'Crea componente di visualizzazione',
  'productTypeStudio.overview.metrics': 'Metriche panoramica',
  'productTypeStudio.overview.attributes': 'Attributi del modello prodotto',
  'productTypeStudio.overview.storefrontVisible': 'Visibili nella vetrina',
  'productTypeStudio.overview.displayComponents': 'Componenti di visualizzazione assegnati',
  'productTypeStudio.templates.catalog': 'Catalogo modelli prodotto',
  'productTypeStudio.templates.activateHint': 'Il salvataggio rende subito il modello disponibile quando crei o modifichi i prodotti.',
  'productTypeStudio.templates.activate': 'Sincronizza catalogo',
  'productTypeStudio.templates.moreActions': 'Azioni',
  'productTypeStudio.templates.selectAll': 'Seleziona tutti',
  'productTypeStudio.templates.clearSelection': 'Deseleziona',
  'productTypeStudio.templates.selectedCount': '{{count}} selezionati',
  'productTypeStudio.templates.activateSelected': 'Sincronizza selezionati',
  'productTypeStudio.templates.exportSelected': 'Esporta ZIP',
  'productTypeStudio.templates.deleteSelected': 'Elimina selezionati',
  'productTypeStudio.templates.export': 'Esporta ZIP',
  'productTypeStudio.templates.selectTemplate': 'Seleziona {{label}}',
  'productTypeStudio.templates.models': 'Modelli',
  'productTypeStudio.templates.averageAttributes': 'Attributi medi',
  'productTypeStudio.templates.search': 'Cerca per ID o nome modello',
  'productTypeStudio.templates.loading': 'Caricamento modelli prodotto...',
  'productTypeStudio.templates.emptyTitle': 'Nessun modello prodotto trovato',
  'productTypeStudio.templates.emptyDescription': 'Parti da un nuovo modello per costruire attributi, pagina prodotto e anteprima vetrina.',
  'productTypeStudio.templates.showing': 'Visualizzazione dei primi {{loaded}} risultati su {{total}}. Usa la ricerca o carica altri risultati.',
  'productTypeStudio.templates.column.model': 'Modello',
  'productTypeStudio.templates.column.attributes': 'Attributi',
  'productTypeStudio.templates.column.version': 'Versione',
  'productTypeStudio.templates.column.updated': 'Aggiornato',
  'productTypeStudio.templates.column.actions': 'Azioni',
  'productTypeStudio.templates.edit': 'Modifica',
  'productTypeStudio.templates.delete': 'Elimina',
  'productTypeStudio.templates.loadMore': 'Carica altri risultati',
  'productTypeStudio.templates.deleteTitle': 'Eliminare il modello prodotto?',
  'productTypeStudio.templates.deleteDescription': 'Conferma l’eliminazione di "{{label}}".',
  'productTypeStudio.templates.deleteConfirm': 'Elimina modello',
  'productTypeStudio.templates.bulkDeleteTitle': 'Eliminare i modelli selezionati?',
  'productTypeStudio.templates.bulkDeleteDescription': 'Conferma l’eliminazione di {{count}} modelli selezionati.',
  'productTypeStudio.attributes.eyebrow': 'Attributi',
  'productTypeStudio.attributes.title': 'Attributi del modello prodotto',
  'productTypeStudio.attributes.description': 'Crea, modifica e organizza gli attributi del modello prodotto senza usare la pagina prodotto.',
  'productTypeStudio.attributes.new': 'Nuovo attributo',
  'productTypeStudio.attributes.emptyTitle': 'Nessun attributo ancora',
  'productTypeStudio.attributes.emptyDescription': 'Crea il primo attributo del modello prodotto. Il sistema gli assegna automaticamente un posizionamento sicuro in Dettagli, senza richiedere uno slot della pagina prodotto.',
  'productTypeStudio.attributes.emptyCreate': 'Crea attributo',
  'productTypeStudio.attributes.column.attribute': 'Attributo',
  'productTypeStudio.attributes.column.type': 'Tipo',
  'productTypeStudio.attributes.column.required': 'Obbligatorio',
  'productTypeStudio.attributes.column.unit': 'Unità',
  'productTypeStudio.attributes.column.variants': 'Varianti',
  'productTypeStudio.attributes.column.placement': 'Posizionamento',
  'productTypeStudio.attributes.column.actions': 'Stato e azioni',
  'productTypeStudio.attributes.deleteTitle': 'Eliminare l’attributo?',
  'productTypeStudio.attributes.deleteDescription': 'L’attributo selezionato verrà rimosso dal modello prodotto.',
  'productTypeStudio.attributes.deleteConfirm': 'Elimina attributo',
  'productTypeStudio.variants.eyebrow': 'Varianti',
  'productTypeStudio.variants.title': 'Comportamento varianti',
  'productTypeStudio.variants.description': 'Definisci quali attributi creano opzioni selezionabili, quali valori possono cambiare per variante e quali attributi restano condivisi.',
  'productTypeStudio.variants.behavior': 'Comportamento varianti',
  'productTypeStudio.variants.enabled': 'Abilitato',
  'productTypeStudio.variants.disabled': 'Disabilitato',
  'productTypeStudio.variants.options': 'Opzioni variante',
  'productTypeStudio.variants.specificFields': 'Campi specifici variante',
  'productTypeStudio.variants.sharedAttributes': 'Attributi condivisi',
  'productTypeStudio.variants.derived': 'Questo riepilogo deriva dai metadati degli attributi. Qui non esiste una configurazione varianti separata da modificare.',
  'productTypeStudio.variants.sectionOptionsTitle': 'Opzioni variante',
  'productTypeStudio.variants.sectionOptionsDescription': 'Attributi che creano scelte selezionabili dal cliente nella pagina prodotto.',
  'productTypeStudio.variants.sectionSpecificTitle': 'Campi specifici variante',
  'productTypeStudio.variants.sectionSpecificDescription': 'Attributi che possono differire per variante senza agire come selettore di opzione.',
  'productTypeStudio.variants.sectionSharedTitle': 'Attributi condivisi',
  'productTypeStudio.variants.sectionSharedDescription': 'Attributi che restano uguali per tutte le varianti.',
  'productTypeStudio.variants.emptyOptions': 'Nessuna opzione variante ancora. Marca un attributo come BTU, Taglia, Colore o Capacità per creare opzioni.',
  'productTypeStudio.variants.emptySpecific': 'Nessun campo specifico variante ancora. Marca un attributo come specifico variante per variare il valore per variante.',
  'productTypeStudio.variants.emptyShared': 'Nessun attributo condiviso ancora.',
  'productTypeStudio.variants.deleteTitle': 'Eliminare l’attributo?',
  'productTypeStudio.variants.deleteDescription': 'L’attributo selezionato verrà rimosso dal modello prodotto.',
  'productTypeStudio.variants.deleteConfirm': 'Elimina attributo',
  'productTypeStudio.productEditorPreview.eyebrow': 'Anteprima editor prodotto',
  'productTypeStudio.productEditorPreview.title': 'Modulo prodotto admin generato',
  'productTypeStudio.productEditorPreview.description': 'Anteprima in sola lettura dei campi dell’editor prodotto generati da questo modello.',
  'productTypeStudio.productEditorPreview.empty': 'Questo modello prodotto non contiene ancora attributi.',
  'productTypeStudio.productEditorPreview.createAttributes': 'Crea attributi',
  'productTypeStudio.productEditorPreview.displayedOrder': 'Mostrato nello stesso ordine dell’editor generato.',
  'productTypeStudio.productEditorPreview.sectionCount': '{{count}} attributo',
  'productTypeStudio.productEditorPreview.sectionCountPlural': '{{count}} attributi',
  'productTypeStudio.productEditorPreview.staticMedia': 'Anteprima media statica',
  'productTypeStudio.productEditorPreview.unit': 'Unità:',
  'productTypeStudio.productEditorPreview.default': 'Predefinito:',
  'productTypeStudio.productEditorPreview.options': 'Opzioni:',
  'productTypeStudio.productEditorPreview.media': 'Media',
  'productTypeStudio.productEditorPreview.required': 'Obbligatorio',
  'productTypeStudio.productEditorPreview.optional': 'Opzionale',
  'productTypeStudio.productEditorPreview.deprecated': 'Deprecato',
  'productTypeStudio.productEditorPreview.source': 'Attributo',
  'productTypeStudio.productEditorPreview.noImage': 'Nessuna immagine disponibile',
  'productTypeStudio.productEditorPreview.yes': 'Sì',
  'productTypeStudio.productEditorPreview.no': 'No',
  'productTypeStudio.productEditorPreview.valueDefault': 'Valore predefinito:',
  'productTypeStudio.productEditorPreview.variantLabelChoice': 'Opzione variante',
  'productTypeStudio.productEditorPreview.variantLabelSpecific': 'Valore specifico variante',
  'productTypeStudio.productEditorPreview.variantLabelShared': 'Valore condiviso',
  'productTypeStudio.productEditorPreview.variantValueChoice': 'Crea scelte selezionabili dal cliente',
  'productTypeStudio.productEditorPreview.variantValueSpecific': 'Può differire per variante',
  'productTypeStudio.productEditorPreview.variantValueShared': 'Condiviso tra tutte le varianti',
  'productTypeStudio.productEditorPreview.mediaAssetPreview': 'Anteprima media',
  'productTypeStudio.productPage.eyebrow': 'Pagina prodotto',
  'productTypeStudio.productPage.title': 'Come i clienti vedono questo modello prodotto',
  'productTypeStudio.productPage.description': 'Gestisci sezioni della vetrina, posizionamenti e componenti di visualizzazione.',
  'productTypeStudio.productPage.sectionsTitle': 'Posizionamento nella vetrina',
  'productTypeStudio.productPage.sectionsDescription': 'Organizza dove compaiono gli attributi esistenti nella pagina prodotto. Usa la scorciatoia secondaria per creare un nuovo attributo solo quando serve.',
  'productTypeStudio.productPage.addSection': '+ Sezione',
  'productTypeStudio.productPage.sectionTitle': 'Titolo sezione',
  'productTypeStudio.productPage.sectionCount': '{{count}} attributi',
  'productTypeStudio.productPage.sectionCountSingular': '{{count}} attributo',
  'productTypeStudio.productPage.sectionHelper': 'Usa questa sezione per posizionare gli attributi esistenti nella pagina della vetrina.',
  'productTypeStudio.productPage.createAttributeHere': 'Crea nuovo attributo in {{zone}} > {{section}}',
  'productTypeStudio.productPage.removeSection': 'Rimuovi',
  'productTypeStudio.productPage.newSection': 'Nuova sezione',
  'productTypeStudio.productPage.zoneLabel': 'Zona della vetrina',
  'productTypeStudio.productPage.zone.summary': 'Riepilogo',
  'productTypeStudio.productPage.zone.highlights': 'In evidenza',
  'productTypeStudio.productPage.zone.specs': 'Specifiche',
  'productTypeStudio.productPage.zone.details': 'Dettagli',
  'productTypeStudio.productPage.zone.documents': 'Documenti',
  'productTypeStudio.productPage.zone.sidebar': 'Barra laterale acquisto',
  'productTypeStudio.productPage.layout.stack': 'Colonna',
  'productTypeStudio.productPage.layout.specTable': 'Tabella specifiche',
  'productTypeStudio.productPage.layout.accordion': 'Fisarmonica',
  'productTypeStudio.productPage.layout.richText': 'Testo formattato',
  'productTypeStudio.productPage.layout.twoColumn': 'Due colonne',
  'productTypeStudio.productPage.previewTitle': 'Anteprima della vetrina',
  'productTypeStudio.productPage.previewHeadline': 'Questo è ciò che vedono i clienti',
  'productTypeStudio.productPage.previewDescription': 'Anteprima in sola lettura della pagina della vetrina generata da questo modello prodotto.',
  'productTypeStudio.productPage.placeTitle': 'Posiziona attributi esistenti',
  'productTypeStudio.productPage.placeDescription': 'Assegna gli attributi esistenti alle sezioni della vetrina e poi riordinali all’interno di ogni sezione. Crea un nuovo attributo solo quando necessario.',
  'productTypeStudio.productPage.noPlacedTitle': 'Nessun attributo posizionato',
  'productTypeStudio.productPage.noPlacedDescription': 'Vai su Attributi per creare prima lo schema, poi posiziona qui gli attributi nella pagina prodotto.',
  'productTypeStudio.productPage.noSectionAttributes': 'Nessun attributo posizionato in questa sezione.',
  'productTypeStudio.productPage.createHere': 'Crea nuovo attributo qui',
  'productTypeStudio.productPage.placement': 'Posizionamento',
  'productTypeStudio.productPage.display': 'Componente di visualizzazione',
  'productTypeStudio.productPage.moveUp': 'Sposta su',
  'productTypeStudio.productPage.moveDown': 'Sposta giù',
  'productTypeStudio.productPage.edit': 'Modifica',
  'productTypeStudio.productPage.advanced': 'Dettagli avanzati',
  'productTypeStudio.productPage.zoneKey': 'Chiave zona',
  'productTypeStudio.productPage.sectionId': 'ID sezione',
  'productTypeStudio.productPage.layoutType': 'Tipo layout',
  'productTypeStudio.productPage.order': 'Ordine',
  'productTypeStudio.productPage.positioning': 'Posizionamento',
  'productTypeStudio.productPage.autoDerived': 'Derivato automaticamente dallo slot selezionato.',
  'productTypeStudio.productPage.placementId': 'ID posizionamento',
  'productTypeStudio.productPage.rendererKey': 'Chiave renderer',
  'productTypeStudio.productPage.technical': 'I metadati tecnici di posizionamento restano nascosti nel flusso primario.',
  'productTypeStudio.publish.eyebrow': 'Pubblica',
  'productTypeStudio.publish.title': 'Prontezza del ciclo di vita',
  'productTypeStudio.publish.description': 'Verifica se questo modello prodotto è pronto, rivedi la validazione e gestisci importazione ed esportazione del pacchetto.',
  'productTypeStudio.publish.attributes': 'Attributi',
  'productTypeStudio.publish.variantOptions': 'Opzioni variante',
  'productTypeStudio.publish.variantSpecificFields': 'Campi specifici variante',
  'productTypeStudio.publish.storefrontSections': 'Sezioni della vetrina',
  'productTypeStudio.publish.displayComponents': 'Componenti di visualizzazione',
  'productTypeStudio.publish.versionInfo': 'Informazioni versione',
  'productTypeStudio.publish.currentState': 'Stato modello corrente',
  'productTypeStudio.publish.modelName': 'Nome modello',
  'productTypeStudio.publish.modelKey': 'Chiave modello',
  'productTypeStudio.publish.currentVersion': 'Versione corrente',
  'productTypeStudio.publish.lastUpdated': 'Ultimo aggiornamento',
  'productTypeStudio.publish.descriptionSummary': 'Riepilogo descrizione',
  'productTypeStudio.publish.validationSummary': 'Riepilogo validazione',
  'productTypeStudio.publish.readinessIndicators': 'Indicatori di prontezza',
  'productTypeStudio.publish.errors': 'Errori',
  'productTypeStudio.publish.warnings': 'Avvisi',
  'productTypeStudio.publish.blockingIssues': 'Problemi bloccanti',
  'productTypeStudio.publish.noBlockingIssues': 'Nessun errore di validazione bloccante rilevato.',
  'productTypeStudio.publish.noWarnings': 'Nessun avviso.',
  'productTypeStudio.publish.packageOperations': 'Operazioni pacchetto',
  'productTypeStudio.publish.packageTitle': 'Importa o esporta il pacchetto di questo modello prodotto',
  'productTypeStudio.publish.packageDescription': 'I metadati del pacchetto restano nelle finestre di dialogo. La scheda Pubblica espone solo le azioni del ciclo di vita.',
  'productTypeStudio.publish.export': 'Esporta pacchetto modello prodotto',
  'productTypeStudio.publish.import': 'Importa pacchetto modello prodotto',
  'productTypeStudio.publish.ready': 'Pronto alla pubblicazione',
  'productTypeStudio.publish.needsAttention': 'Richiede attenzione',
  'productTypeStudio.publish.atRiskDeprecated': 'Attributi deprecati presenti: {{count}}',
  'productTypeStudio.publish.atRiskHidden': 'Attributi nascosti presenti: {{count}}',
  'productTypeStudio.publish.importTitle': 'Importa pacchetto modello prodotto',
  'productTypeStudio.publish.importDescription': 'Carica il pacchetto, rivedi i conflitti e scegli come gestirli durante l’importazione.',
  'productTypeStudio.publish.packageZip': 'Pacchetto ZIP',
  'productTypeStudio.publish.selectedFile': 'File selezionato',
  'productTypeStudio.publish.conflictHandling': 'Gestione conflitti',
  'productTypeStudio.publish.blockImport': 'Blocca importazione (consigliato)',
  'productTypeStudio.publish.replaceExisting': 'Sostituisci elementi esistenti',
  'productTypeStudio.publish.duplicateExisting': 'Duplica con un nuovo identificatore',
  'productTypeStudio.publish.validate': 'Valida pacchetto',
  'productTypeStudio.publish.importInstall': 'Importa e installa',
  'productTypeStudio.publish.exportZip': 'Esporta ZIP',
  'productTypeStudio.publish.includeRenderers': 'Includi i componenti di visualizzazione personalizzati dipendenti',
  'productTypeStudio.publish.cancel': 'Annulla',
  'productTypeStudio.publish.currentVersionLabel': 'Versione corrente',
  'productTypeStudio.publish.descriptionLabel': 'Riepilogo descrizione',
  'productTypeStudio.publish.lastUpdatedLabel': 'Ultimo aggiornamento',
  'productTypeStudio.publish.modelKeyLabel': 'Chiave modello',
  'productTypeStudio.publish.modelNameLabel': 'Nome modello',
  'productTypeStudio.publish.loading': 'Caricamento dati tecnici...',
  'productTypeStudio.publish.exportTitle': 'Esporta pacchetto modello prodotto',
  'productTypeStudio.publish.exportDescription': 'Crea un pacchetto ZIP portabile per questo modello prodotto.',
  'productTypeStudio.publish.includeDependentRenderers': 'Includi i componenti di visualizzazione personalizzati dipendenti',
  'productTypeStudio.publish.inspectionAttributes': 'Attributi',
  'productTypeStudio.publish.inspectionSections': 'Sezioni',
  'productTypeStudio.publish.inspectionIncludedComponents': 'Componenti di visualizzazione inclusi',
  'productTypeStudio.publish.inspectionProductConflicts': 'Conflitti modello prodotto',
  'productTypeStudio.publish.inspectionComponentConflicts': 'Conflitti componenti di visualizzazione',
  'productTypeStudio.publish.yes': 'Sì',
  'productTypeStudio.publish.no': 'No',
  'productTypeStudio.publish.surface': 'Area Pubblica',
  'productTypeStudio.advanced.eyebrow': 'Avanzate',
  'productTypeStudio.advanced.title': 'Metadati tecnici e diagnostica',
  'productTypeStudio.advanced.description': 'Identificatori interni, metadati di posizionamento, diagnostica e gestione dei componenti di visualizzazione vivono qui.',
  'productTypeStudio.advanced.loading': 'Caricamento dati tecnici...',
  'productTypeStudio.advanced.surface': 'Area Avanzate',
  'productTypeStudio.advanced.modelMetadata': 'Metadati modello',
  'productTypeStudio.advanced.identifiers': 'Identificatori e stato modello',
  'productTypeStudio.advanced.recordId': 'ID record',
  'productTypeStudio.advanced.attributeMetadata': 'Metadati attributo',
  'productTypeStudio.advanced.placementSummaries': 'Riepilogo posizionamenti e dati tecnici grezzi',
  'productTypeStudio.advanced.visibleAttributes': 'Attributi visibili',
  'productTypeStudio.advanced.rawAttributePlacement': 'Metadati grezzi di posizionamento attributi',
  'productTypeStudio.advanced.rawSectionReferences': 'Riferimenti grezzi alle sezioni',
  'productTypeStudio.advanced.sectionTitle': 'Titolo',
  'productTypeStudio.advanced.rawAttributes': 'Attributi',
  'productTypeStudio.advanced.rawSections': 'Sezioni della vetrina',
  'productTypeStudio.advanced.technicalDiagnostics': 'Diagnostica tecnica',
  'productTypeStudio.advanced.displayHealth': 'Stato dei componenti di visualizzazione',
  'productTypeStudio.advanced.registryItems': 'Elementi del registro',
  'productTypeStudio.advanced.valid': 'Validi',
  'productTypeStudio.advanced.invalid': 'Non validi',
  'productTypeStudio.advanced.draft': 'Bozza',
  'productTypeStudio.advanced.modelName': 'Nome modello',
  'productTypeStudio.advanced.modelKey': 'Chiave modello',
  'productTypeStudio.advanced.currentVersion': 'Versione corrente',
  'productTypeStudio.advanced.lastUpdated': 'Ultimo aggiornamento',
  'productTypeStudio.advanced.descriptionSummary': 'Riepilogo descrizione',
  'productTypeStudio.advanced.attribute': 'Attributo',
  'productTypeStudio.advanced.key': 'Chiave',
  'productTypeStudio.advanced.zoneKey': 'Chiave zona',
  'productTypeStudio.advanced.sectionId': 'ID sezione',
  'productTypeStudio.advanced.position': 'Posizione',
  'productTypeStudio.advanced.rendererKey': 'Chiave renderer',
  'productTypeStudio.advanced.variant': 'Variante',
  'productTypeStudio.advanced.layout': 'Struttura',
  'productTypeStudio.advanced.order': 'Ordine',
  'productTypeStudio.advanced.name': 'Nome',
  'productTypeStudio.advanced.version': 'Versione',
  'productTypeStudio.advanced.author': 'Autore',
  'productTypeStudio.advanced.entry': 'Ingresso',
  'productTypeStudio.advanced.icon': 'Icona',
  'productTypeStudio.advanced.surfaces': 'Superfici',
  'productTypeStudio.advanced.updated': 'Aggiornato',
  'productTypeStudio.advanced.manifestFieldTypes': 'Tipi campo manifesto',
  'productTypeStudio.advanced.packageStructure': 'Struttura pacchetto',
  'productTypeStudio.advanced.validationErrors': 'Errori di validazione',
  'productTypeStudio.advanced.noPackageFiles': 'Nessun file del pacchetto disponibile.',
  'productTypeStudio.advanced.zip': 'ZIP',
  'productTypeStudio.registry.registry': 'Componenti di visualizzazione',
  'productTypeStudio.registry.title': 'Registro dei componenti di visualizzazione personalizzati',
  'productTypeStudio.registry.description': 'Registro sicuro per pacchetti ZIP di componenti di visualizzazione. Nessun codice personalizzato viene eseguito a runtime.',
  'productTypeStudio.registry.packageSpec': 'Specifiche ZIP del pacchetto',
  'productTypeStudio.registry.expectedStructure': 'Struttura attesa:',
  'productTypeStudio.registry.requiredManifest': 'Manifest richiesto: name, key, description, entry, supportedFieldTypes. Opzionali: version, author, icon, surfaces.',
  'productTypeStudio.registry.deleteTitle': 'Eliminare il componente di visualizzazione?',
  'productTypeStudio.registry.deleteConfirm': 'Elimina componente di visualizzazione',
  'productTypeStudio.registry.loading': 'Caricamento componenti di visualizzazione...',
  'productTypeStudio.registry.emptyTitle': 'Nessun componente di visualizzazione registrato',
  'productTypeStudio.registry.emptyDescription': 'Crea una bozza di componente di visualizzazione o carica un pacchetto ZIP per la validazione strutturale.',
  'productTypeStudio.registry.showing': 'Visualizzazione dei primi {{loaded}} componenti di visualizzazione su {{total}}. Restringi i filtri o carica altri risultati.',
  'productTypeStudio.registry.updated': 'Aggiornato:',
  'productTypeStudio.registry.download': 'Scarica',
  'productTypeStudio.registry.details': 'Dettagli',
  'productTypeStudio.registry.loadingMore': 'Caricamento...',
  'productTypeStudio.registry.loadMore': 'Carica altri componenti di visualizzazione',
  'productTypeStudio.registry.name': 'Nome',
  'productTypeStudio.registry.version': 'Versione',
  'productTypeStudio.registry.descriptionLabel': 'Descrizione',
  'productTypeStudio.registry.mode': 'Modalità',
  'productTypeStudio.registry.uploadZip': 'Carica pacchetto ZIP',
  'productTypeStudio.registry.dragDrop': 'Trascina e rilascia oppure seleziona un file',
  'productTypeStudio.registry.inlineJsCode': 'Codice JS del componente di visualizzazione (ingresso: index.js)',
  'productTypeStudio.registry.create': 'Crea componente di visualizzazione',
  'productTypeStudio.registry.createing': 'Creazione...',
  'productTypeStudio.registry.deleteDescription': 'Conferma l’eliminazione del componente di visualizzazione "{{name}}".',
  'productTypeStudio.registry.infoPackage': 'Metadati pacchetto',
  'productTypeStudio.registry.status': 'Stato',
  'productTypeStudio.registry.type': 'Tipo',
  'productTypeStudio.registry.close': 'Chiudi',
}

export default productTypeStudioMessages
